import React from "react";
import { FormFieldTypes } from "../../../data/formFieldType";
import CommitteeApprovalTable from "./CommitteeApprovalTable";

export const CreateGMPCourseData = {
  name: "CreateGMPCourseData",
  initialState: {
    organisationName: '',
    UENNumber: "",
    mailingAddress1: "",
    mailingAddress2: "",
    country: null,
    postalCode: "",
    organisationWebsite: "",
    organisationLogo: "",
    shortDescriptionofOrganisation: "",
    organizationfalls: "no",
    nameofRepresentative: "",
    emailAddress: "",
    contactNumber: "",
    alternateNameOfRepresentative: "",
    alternateEmailAddress: "",
    alternateContactNumber: "",
  },

  formFields: [
    {
      id: "applicantOrganisationProfile",
      lable: "",
      Field_Name: "personalParticularstitle",
      fieldType: FormFieldTypes.MAINFORMTITLE,
      dataField: "applicantOrganisationProfile",
      fieldSetting: {
        formTitle: "Applicant Organisation Profile",
      },
      style: {
        containerCss: "col-lg-12 mb-2 text-left form-title",
      },
    },
    {
      id: "organisationName",
      lable: "Organisation Name",
      Field_Name: "Organisation Name",
      fieldType: FormFieldTypes.INPUT,
      dataField: "organisationName",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-md-6 mb-3",
      },
    },
    {
      id: "UENNumber",
      lable: "UEN Number",
      Field_Name: "UEN Number",
      fieldType: FormFieldTypes.INPUT,
      dataField: "UENNumber",
      fieldSetting: {
        placeholder: "",
        allowSpace: false,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-md-6 mb-3",
      },
    },
    {
      id: "mailingAddress1",
      lable: "Mailing Address Line 1 ",
      Field_Name: "Mailing Address Line 1 ",
      fieldType: FormFieldTypes.INPUT,
      dataField: "mailingAddress1",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-md-6 mb-3",
      },
    },
    {
      id: "mailingAddress2",
      lable: "Mailing Address Line 2",
      Field_Name: "Mailing Address Line 2 ",
      fieldType: FormFieldTypes.INPUT,
      dataField: "mailingAddress2",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      // validation: [{ type: "require" }],
      style: {
        containerCss: "col-md-6 mb-3",
      },
    },
    {
      id: "country",
      lable: "Country",
      Field_Name: "Country",
      fieldType: FormFieldTypes.SELECT,
      dataField: "country",
      fieldSetting: {
        placeholder: "",
        options: [],
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-md-6 mb-2",
      },
    },
    {
      id: "postalCode",
      lable: "Postal Code",
      Field_Name: "Postal Code",
      fieldType: FormFieldTypes.NUMERIC,
      dataField: "postalCode",
      fieldSetting: {
        placeholder: "",
        allowSpace: false,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-md-6 mb-2",
      },
    },
    {
      id: "organisationWebsite",
      lable: "Organisation Website",
      Field_Name: "Organisation Website ",
      fieldType: FormFieldTypes.INPUT,
      dataField: "organisationWebsite",
      fieldSetting: {
        placeholder: "",
        allowSpace: false,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-md-6 mb-3",
      },
    },
    {
      id: "organisationLogo",
      lable: "Organisation Logo (please upload in jpg/png format max 2mb)",
      Field_Name: "file",
      fieldType: FormFieldTypes.FILE,
      dataField: "organisationLogo",
      fieldSetting: {
        // presentFileName: null,
        placeholder: "",
        // isDownloadable: false,
        acceptedFiles: ".jpg, .png",
        imageCrop: true,
        viewImage: true,
        maxFileSizeInKB: 2048,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-md-6 mb-2",
      },
    },
    {
      id: "shortDescriptionofOrganisation",
      lable: "Short Description of Organisation",
      Field_Name: "Short Description of Organisation",
      fieldType: FormFieldTypes.TEXTAREA,
      dataField: "shortDescriptionofOrganisation",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
        maxWords: 100,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-md-12 mb-2",
      },
    },
    {
      id: "organizationfalls",
      label:
        "Your organization falls into one of the following categories: government agencies, professional bodies, or relevant trade associations.",
      Field_Name:
        "Your organization falls into one of the following categories: government agencies, professional bodies, or relevant trade associations.",
      fieldType: FormFieldTypes.RADIOBUTTON,
      dataField: "organizationfalls",
      fieldSetting: {
        placeholder: "",
        options: [
          { label: "Yes", value: "yes", isDisable: true, optionClass: "" },
          {
            label: "No", value: "no", isDisable: true,  //   optionClass: "ml-3",
          },
        ],
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-12 mb-4",
      },
    },
    {
      fieldType: FormFieldTypes.SEPARATOR,
      style: {
        containerCss: "separation-line pl-0 pr-0",
      },
    },
    {
      id: "applicantRepresentativeDetails",
      lable: "Applicant Representative Details",
      Field_Name: "applicantRepresentativeDetails",
      fieldType: FormFieldTypes.MAINFORMTITLE,
      dataField: "applicantRepresentativeDetails",
      fieldSetting: {
        formTitle: "Applicant Representative Details",
      },
      style: {
        containerCss: "col-lg-12 mb-2 text-left  form-title",
      },
    },
    {
      id: "nameofRepresentative",
      lable: "Name of Representative",
      Field_Name: "Name of Representative",
      fieldType: FormFieldTypes.INPUT,
      dataField: "nameofRepresentative",
      fieldSetting: {
        placeholder: "",
        allowSpace: false,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-md-6 mb-3",
      },
    },
    {
      id: "emailAddress",
      lable: "Email Address",
      Field_Name: "Email Address",
      fieldType: FormFieldTypes.INPUT,
      dataField: "emailAddress",
      fieldSetting: {
        placeholder: "",
        allowSpace: false,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-md-6 mb-3",
      },
    },
    {
      id: "contactNumber",
      lable: "Contact Number",
      Field_Name: "Contact Number",
      fieldType: FormFieldTypes.NUMERIC,
      dataField: "contactNumber",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-md-6 mb-2",
      },
    },
    {
      fieldType: FormFieldTypes.SEPARATOR,
      style: {
        containerCss: "separation-border pl-0 pr-0 mb-2",
      },
    },
    {
      id: "alternateNameOfRepresentative",
      lable: "Name of Alternate Representative",
      Field_Name: "Name of Alternate Representative",
      fieldType: FormFieldTypes.INPUT,
      dataField: "alternateNameOfRepresentative",
      fieldSetting: {
        placeholder: "",
        allowSpace: false,
      },
      // validation: [{ type: "require" }],
      style: {
        containerCss: "col-md-6 mb-3",
      },
    },
    {
      id: "alternateEmailAddress",
      lable: "Email Address",
      Field_Name: "Email Address",
      fieldType: FormFieldTypes.INPUT,
      dataField: "alternateEmailAddress",
      fieldSetting: {
        placeholder: "",
        allowSpace: false,
      },
      // validation: [{ type: "require" }],
      style: {
        containerCss: "col-md-6 mb-3",
      },
    },
    {
      id: "alternateContactNumber",
      lable: "Contact Number",
      Field_Name: "Contact Number",
      fieldType: FormFieldTypes.NUMERIC,
      dataField: "alternateContactNumber",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      // validation: [{ type: "require" }],
      style: {
        containerCss: "col-md-6 mb-2",
      },
    },
  ],

  formSetting: {
    isViewOnly: false,
  },
};

export const StaffApprovalData = {
  name: "StaffApprovalData",

  initialState: {
    internalComments: "",
    sendforCommitteeApproval: false,
  },

  formFields: [
    {
      id: "applicantOrganisationProfile",
      lable: "",
      Field_Name: "decisionCard-StaffApproval",
      fieldType: FormFieldTypes.MAINFORMTITLE,
      dataField: "decisionCard-StaffApproval",
      fieldSetting: {
        formTitle: "Decision Card - Staff Approval",
      },
      style: {
        containerCss: "col-lg-12 mb-2 text-left form-title",
      },
    },
    {
      id: "internalComments",
      lable: "Internal Comments",
      Field_Name: "Internal Comments",
      fieldType: FormFieldTypes.TEXTAREA,
      dataField: "internalComments",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
        maxLength: 500,
      },
      // validation: [{ type: "require" }],
      style: {
        containerCss: "col-md-12 mb-2",
      },
    },

    {
      id: "sendforCommitteeApproval",
      lable: "Send for Committee Approval",
      Field_Name: "Send for Committee Approval",
      fieldType: FormFieldTypes.CHECKBOX,
      dataField: "sendforCommitteeApproval",
      fieldSetting: {
        isDisable: false,
      },
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 col-12  mb-3",
      },
    },
  ],

  formSetting: {
    isViewOnly: false,
  },
};

export const CommitteeApprovalData = {
  name: "CommitteeApprovalData",

  initialState: {
    committeApproval: "",
    internalComments: ""
  },

  formFields: [
    {
      id: "applicantOrganisationProfile",
      lable: "",
      Field_Name: "decisionCard-CommitteeApproval",
      fieldType: FormFieldTypes.MAINFORMTITLE,
      dataField: "decisionCard-CommitteeApproval",
      fieldSetting: {
        formTitle: "Decision Card - Committee Approval",
      },
      style: {
        containerCss: "col-lg-12 mb-2 text-left form-title",
      },
    },
    {
      id: "committeApproval",
      fieldType: FormFieldTypes.COMPONENT,
      additionalComponent: <CommitteeApprovalTable />,
      style: {
        containerCss: "col-lg-8 mb-2 text-left form-title",
      },
    },
    {
      id: "internalComments",
      lable: "Internal Comments",
      Field_Name: "Internal Comments",
      fieldType: FormFieldTypes.TEXTAREA,
      dataField: "internalComments",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
        maxLength: 500,
      },
      // validation: [{ type: "require" }],
      style: {
        containerCss: "col-md-12 mb-2",
      },
    },
  ],

  formSetting: {
    isViewOnly: false,
  },
};
